export default () => {
  const hotspotTarget = document.querySelectorAll('[data-hotspot-target]')
  const mobPositionStyles = [
    ['leftTop', { left: '3.4rem', top: '-1.7rem' }],
    ['leftBottom', { left: '3.4rem', top: '-20.5rem' }],
    ['rightTop', { left: '-17.9rem', top: '-1.7rem' }],
    ['rightBottom', { left: '-17.9rem', top: '-22.3rem' }],
    ['topArrow', { left: '-7.25rem', top: '3.4rem' }],
    ['bottomArrow', { left: '-7.25rem', top: '-27.4rem' }],
  ];

  const init = hotspot => {
    const { dataset: { hotspotimgdesktop, hotspotimgmobile } } = hotspot;
    const hotspots = Array.from(hotspot.querySelectorAll('[data-hotspots]'));
    const closeIcons = Array.from(hotspot.querySelectorAll('.iwh__hotspot-content-close-btn'));
  
    hotspots.forEach(hotspot => {
      const { dataset: { hotspotsDesktop, hotspotsMobile } } = hotspot;
      const desktopPoints = hotspotsDesktop.split(',');
      const mobilePoints = hotspotsMobile.split(',');
  
      hotspot.children[0].classList.remove('active');
  
      if (window.innerWidth > 767) {
        desktopPoints.forEach(point => hotspotPosition(point, JSON.parse(hotspotimgdesktop), hotspot, hotspots, 'desktop'));
      } else {
        mobilePoints.forEach(point => hotspotPosition(point, JSON.parse(hotspotimgmobile), hotspot, hotspots, 'mobile'));
      }
    });
  
    closeIcons.forEach(closeIcon => {
      closeIcon.addEventListener('click', event => {
        event.stopPropagation();
        closeDialog(closeIcon);
      });

      closeIcon.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.stopPropagation();
          closeDialog(closeIcon);
        }
      });
    });
  };

  const closeDialog = (closeIcon) => {
    closeIcon.parentElement.parentElement.classList.remove('active');
    closeIcon.parentElement.parentElement.setAttribute('aria-hidden', true);
    updateAriaExpanded(false, closeIcon.parentElement.parentElement.parentElement);
  };

  const hotspotPosition = (point,image,hotspot,hotspots,device) => {
    const xy = point.trim().split('-')
    const left = Number(xy[0])/image.width * 100
    const top = Number(xy[1])/image.height * 100
    hotspot.setAttribute('style', `left: ${left}%; top: ${top}%`)

    hotspot.addEventListener('click', () => {
      activateHotspotModal(hotspot,hotspots,device,left);
    })

    hotspot.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        activateHotspotModal(hotspot,hotspots,device,left);
      }
    })
  }

  const activateHotspotModal = (hotspot,hotspots,device,left) => {
    hotspots.forEach(el => el.children[0].classList.remove('active'))
    device === 'desktop' ? desktopEle(top,left,hotspot.children[0]) : mobileEle(top,left,hotspot.children[0],mobPositionStyles)
    hotspot.children[0].classList.add('active')
    hotspot.children[0].setAttribute('aria-hidden', false);
    updateAriaExpanded(true, hotspot);
  }

  const desktopEle = (elementTop, elementLeft, element) => {
    const positionMap = {
      leftTop: { left: '4.8rem', top: '-1.2rem' },
      leftBottom: { left: '4.8rem', top: '-29.5rem' },
      rightTop: { left: '-23.8rem', top: '-1.2rem' },
      rightBottom: { left: '-23.8rem', top: '-31.3rem' },
    };
    
    const MAX_TOP = 60;
    const MAX_LEFT = 70;
  
    const key = elementTop <= MAX_TOP
      ? elementLeft <= MAX_LEFT ? 'leftTop' : 'rightTop'
      : elementLeft <= MAX_LEFT ? 'leftBottom' : 'rightBottom';
  
    const { left, top } = positionMap[key];
    const style = `left: ${left}; top: ${top}`;
    const className = key;
  
    element.setAttribute('style', style);
    element.classList.add(className);
  };
  
  
  const mobileEle = (top, left, element, positionStyles) => {
    const positionMap = new Map(positionStyles);
  
    let key = '';
    if (top <= 50 && left <= 35) {
      key = 'leftTop';
    } else if (top > 50 && left <= 35) {
      key = 'leftBottom';
    } else if (top <= 50 && left >= 60) {
      key = 'rightTop';
    } else if (top > 50 && left >= 60) {
      key = 'rightBottom';
    } else if (top <= 50 && left > 35 && left < 60) {
      key = 'topArrow';
    } else {
      key = 'bottomArrow';
    }
  
    const { left: newLeft, top: newTop } = positionMap.get(key);
    const style = `left: ${newLeft}; top: ${newTop}`;
  
    element.setAttribute('style', style);
    element.classList.add(key);
  };

  const updateAriaExpanded = (isOpen, hotspotButton) => {
    hotspotButton.setAttribute('aria-expanded', isOpen);
  };
  
  window.onresize = function(){ hotspotTarget.forEach(el => init(el)) }
  hotspotTarget.forEach(el => init(el))
}